import {Component, Object3D} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {Bullet} from './bullet.js';
import {Team} from './utils/team.js';

/**
 * bullet-pool
 */
export class BulletPool extends Component {
    static TypeName = 'bullet-pool';

    @property.int(10)
    count!: number;

    bullets: Bullet[] = [];
    prototype?: Object3D;

    current: number = 0;

    start() {
        this.prototype = this.object.children[0]!;
        const splatMesh = this.prototype.getComponent(Bullet)!.splatMesh;
        this.bullets = new Array(this.count);
        for (let i = 0; i < this.count; ++i) {
            try {
                const clone = this.prototype.clone();
                this.bullets[i] =
                    clone.getComponent(Bullet)! ||
                    clone.addComponent(Bullet, {
                        splatMesh: splatMesh,
                        active: false,
                    })!;
            } catch (e) {
                /* memory access out of bounds, try again */
                console.log('Memory access during clone(), retrying');
                --i;
            }
        }
    }

    shoot() {
        const b = this.bullets[this.current];
        this.current = (this.current + 1) % this.count;
        b.resetBullet();
        return b;
    }
}
